import React from "react";

interface TextContextValue {
  text: Record<string, string>;
}

const TextContext = React.createContext<TextContextValue>({
  text: {}
});

interface TextProviderProps {
  children?: React.ReactNode;
  text: Record<string, string>;
}

export const TextProvider: React.FC<TextProviderProps> = ({ children, text }) => {
  return <TextContext.Provider value={{ text }}>{children}</TextContext.Provider>;
};

export const useText = () => {
  const { text } = React.useContext(TextContext);

  return {
    getText: React.useCallback(
      (key: string) => {
        const textValue = text[key];

        if (textValue !== undefined) {
          return textValue;
        }

        if (typeof window !== "undefined") {
          // eslint-disable-next-line no-console
          console.warn(`Text key '${key}' does not exist`);
        }

        return "";
      },
      [text]
    )
  };
};
